import { useQuery } from '@tanstack/react-query';

import { Api } from '@/shared/api';
import { useCurrentProject } from '@/shared/projects/project-path';

export function useGetAuthors() {
  const project = useCurrentProject();
  return useQuery({
    queryKey: [project, 'authors'],
    initialData: {
      authors: [],
    },
    queryFn: () => Api.authors.getAuthors(project),
  });
}
